<template>
  <div class="dashboard-page">
    <h1 class="page-title">Dashboard</h1>
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="bg-transparent">
          <b-tab title="Berusaha" active>
            <b-row>
              <!-- <b-col lg="12">
            <iframe width="100%" height="400px" src="https://pprl.maps.arcgis.com/apps/webappviewer/index.html?id=895835c666b54fdcb3e272ca67773c30" frameborder="0"></iframe>
          </b-col> -->
              <b-col lg="3" md="6" xs="12">
                <Widget>
                  <div class="clearfix">
                    <div class="row flex-nowrap">
                      <div class="col-3">
                        <span class="widget-icon">
                          <i class="fa fa-user text-primary" />
                        </span>
                      </div>
                      <div class="col-9">
                        <h6 class="m-0">PERMOHONAN</h6>
                        <p class="h2 m-0 fw-normal">
                          {{ dataDashboard.permohonan }}
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row flex-nowrap">
                  <div class="col-6">
                    <h6 class="m-0">Registrations</h6>
                    <p class="value5">+830</p>
                  </div>
                  <div class="col-6">
                    <h6 class="m-0">Bounce Rate</h6>
                    <p class="value5">4.5%</p>
                  </div>
                </div> -->
                  </div>
                </Widget>
              </b-col>
              <b-col lg="3" md="6" xs="12">
                <Widget>
                  <div class="clearfix">
                    <div class="row flex-nowrap">
                      <div class="col-3">
                        <span class="widget-icon">
                          <i class="fa fa-hourglass-half text-primary" />
                        </span>
                      </div>
                      <div class="col-9">
                        <h6 class="m-0">PROSES</h6>
                        <p class="h2 m-0 fw-normal">
                          {{ dataDashboard.proses }}
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row flex-nowrap">
                  <div class="col-6">
                    <h6 class="m-0">Registrations</h6>
                    <p class="value5">+830</p>
                  </div>
                  <div class="col-6">
                    <h6 class="m-0">Bounce Rate</h6>
                    <p class="value5">4.5%</p>
                  </div>
                </div> -->
                  </div>
                </Widget>
              </b-col>
              <b-col lg="3" md="6" xs="12">
                <Widget>
                  <div class="clearfix">
                    <div class="row flex-nowrap">
                      <div class="col-3">
                        <span class="widget-icon">
                          <i class="fa fa-file-text-o text-primary" />
                        </span>
                      </div>
                      <div class="col-9">
                        <h6 class="m-0">PERBAIKAN PERSYARATAN</h6>
                        <p class="h2 m-0 fw-normal">
                          {{ dataDashboard.perbaikan_persyaratan }}
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row flex-nowrap">
                  <div class="col-6">
                    <h6 class="m-0">Registrations</h6>
                    <p class="value5">+830</p>
                  </div>
                  <div class="col-6">
                    <h6 class="m-0">Bounce Rate</h6>
                    <p class="value5">4.5%</p>
                  </div>
                </div> -->
                  </div>
                </Widget>
              </b-col>
              <b-col lg="3" md="6" xs="12">
                <Widget>
                  <div class="clearfix">
                    <div class="row flex-nowrap">
                      <div class="col-3">
                        <span class="widget-icon">
                          <i class="fa fa-check-square text-primary" />
                        </span>
                      </div>
                      <div class="col-9">
                        <h6 class="m-0">SELESAI</h6>
                        <p class="h2 m-0 fw-normal">
                          {{ dataDashboard.selesai }}
                        </p>
                      </div>
                    </div>
                    <!-- <div class="row flex-nowrap">
                  <div class="col-6">
                    <h6 class="m-0">Registrations</h6>
                    <p class="value5">+830</p>
                  </div>
                  <div class="col-6">
                    <h6 class="m-0">Bounce Rate</h6>
                    <p class="value5">4.5%</p>
                  </div>
                </div> -->
                  </div>
                </Widget>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12">
                <IzinProvChart :data="mainChart" :isReceiving="isReceiving" />
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12">
                <IzinPNBPChart :data="mainChart" :isReceiving="isReceiving" />
              </b-col>
            </b-row>
            <b-row>
              <!-- <b-col xs="4" md="4">
            <MainChart :data="mainChart" :isReceiving="isReceiving" />
          </b-col> -->
              <b-col xs="5" md="5">
                <IzinYearChart :data="mainChart" :isReceiving="isReceiving" />
              </b-col>
              <b-col xs="7" md="7">
                <Widget
                  title="<h5>Data Permohonan</h5>"
                  bodyClass="widget-table-overflow"
                  customHeader
                >
                  <div class="my-3">
                    <div class="table-responsive mb-3 datatables">
                      <b-table
                        striped
                        hover
                        :items="itemsWithNumber"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                      >
                        <template #cell(tanggal_pada_permohonan)="data">
                          {{ format_date(data.item.tanggal_pada_permohonan) }}
                        </template>
                      </b-table>
                    </div>
                    <div class="row mb-md-2">
                      <div class="col-sm-12 col-md-6 mx-3">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            <b-form-select
                              class="form-control form-control-sm form-select form-select-sm"
                              v-model="perPage"
                              size="sm"
                              :options="pageOptions"
                            ></b-form-select>
                          </label>
                        </div>
                      </div>
                      <!-- Search -->
                      <div class="col-sm-12 col-md-6"></div>
                      <!-- End search -->
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="dataTables_paginate paging_simple_numbers float-end m-3"
                        >
                          <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                            ></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </Widget>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Non Berusaha">
            <h2>Maaf, Sedang dalam pengembangan. 😎</h2>
            <!-- <b-row>
              <b-col md="3">
                <b-row>
                  <b-col md="12" style="height: 50%">
                    <Widget>
                      <div class="clearfix">
                        <div class="row flex-nowrap">
                          <div class="col-4">
                            <span class="widget-icon">
                              <i class="fa fa-file-text-o text-primary" />
                            </span>
                          </div>
                          <div class="col-8">
                            <h6 class="m-0">PERMOHONAN</h6>
                            <p class="h2 m-0 fw-normal">
                              {{ dataDashboard.permohonan }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Widget>
                  </b-col>
                  <b-col md="12">
                    <Widget>
                      <div class="clearfix">
                        <div class="row flex-nowrap">
                          <div class="col-4">
                        <span class="widget-icon">
                          <i class="fa fa-credit-card text-primary" />
                        </span>
                      </div>
                          <div class="col-8">
                            <h6 class="m-0">CAPAIAN REALISASI PNBP</h6>
                            <p class="h2 m-0 fw-normal">
                              {{ dataDashboard.permohonan }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Widget>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="9">
                <b-row>
                  <b-col md="6">
                    <b-row>
                      <b-col md="12">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-3">
                                <span class="widget-icon">
                                  <i
                                    class="fa fa-hourglass-start text-warning"
                                  />
                                </span>
                              </div>
                              <div class="col-9">
                                <h6 class="m-0">PROSES</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">MENUNGGU VERDOK</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">MENUNGGU PENTEK</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">PEMBUATAN BERITA ACARA</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">PEMBUATAN TAGIHAN PNBP</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">MENUNGGU PEMBAYARAN PNBP</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">PEMBUATAN MEMO</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="6">
                    <b-row>
                      <b-col md="12">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-3">
                                <span class="widget-icon">
                                  <i class="fa fa-check text-success" />
                                </span>
                              </div>
                              <div class="col-9">
                                <h6 class="m-0">SELESAI</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">TERBIT</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">TOLAK</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                      <b-col md="4">
                        <Widget>
                          <div class="clearfix">
                            <div class="row flex-nowrap">
                              <div class="col-12">
                                <h6 class="m-0">TIDAK LOLOS VERIF. ADMIN</h6>
                                <p class="h2 m-0 fw-normal">
                                  {{ dataDashboard.permohonan }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Widget>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row> -->
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Widget from "@/components/Widget/Widget";
import MainChart from "./components/MainChart/MainChart";
import BigStat from "./components/BigStat/BigStat";
import Calendar from "../Visits/components/Calendar/Calendar";
import TaskContainer from "./components/TaskContainer/TaskContainer";
import mock from "./mock";
import axios from "axios";
import moment from "moment";

import { Chart } from "highcharts-vue";
import IzinProvChart from "./components/MainChart/IzinProvChart.vue";
import IzinPNBPChart from "./components/MainChart/IzinPNBPChart.vue";
import IzinYearChart from "./components/MainChart/IzinYearChart.vue";

export default {
  name: "Dashboard",
  components: {
    Widget,
    MainChart,
    BigStat,
    Calendar,
    TaskContainer,
    highcharts: Chart,
    IzinProvChart,
    IzinYearChart,
    IzinPNBPChart,
  },
  data() {
    return {
      mock,
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      dataPermohonan: [],
      dataDashboard: [],
      table: [
        {
          id: 0,
          name: "Mark Otto",
          email: "ottoto@wxample.com",
          product: "ON the Road",
          price: "$25 224.2",
          date: "11 May 2017",
          city: "Otsego",
          status: "Sent",
        },
        {
          id: 1,
          name: "Jacob Thornton",
          email: "thornton@wxample.com",
          product: "HP Core i7",
          price: "$1 254.2",
          date: "4 Jun 2017",
          city: "Fivepointville",
          status: "Sent",
        },
        {
          id: 2,
          name: "Larry the Bird",
          email: "bird@wxample.com",
          product: "Air Pro",
          price: "$1 570.0",
          date: "27 Aug 2017",
          city: "Leadville North",
          status: "Pending",
        },
        {
          id: 3,
          name: "Joseph May",
          email: "josephmay@wxample.com",
          product: "Version Control",
          price: "$5 224.5",
          date: "19 Feb 2018",
          city: "Seaforth",
          status: "Declined",
        },
        {
          id: 4,
          name: "Peter Horadnia",
          email: "horadnia@wxample.com",
          product: "Let's Dance",
          price: "$43 594.7",
          date: "1 Mar 2018",
          city: "Hanoverton",
          status: "Sent",
        },
      ],
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_verdok", label: "Status", sortable: true },
        { key: "tanggal_permohonan", label: "Tanggal Permohonan" },
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
      items: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      totalRows: 1,
    };
  },
  methods: {
    ...mapActions("dashboard", ["receiveDataRequest"]),
    getRandomData() {
      const arr = [];

      for (let i = 0; i < 25; i += 1) {
        arr.push(Math.random().toFixed(1) * 10);
      }

      return arr;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    loaddata() {
      axios
        .get(this.baseapi + "api/permohonan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    loadDataDashboard() {
      axios
        .get(this.baseapi + "api/dashboard/web", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          console.log(response.data.data);
          
          this.dataDashboard = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
  },
  computed: {
    ...mapState("dashboard", [
      "visits",
      "performance",
      "server",
      "revenue",
      "mainChart",
      "isReceiving",
    ]),
    itemsWithNumber() {
      return this.dataPermohonan.map((d, index) => ({ ...d, no: index + 1 }));
    },
    rows() {
      return this.dataPermohonan.length;
    },
    donut() {
      let { danger, warning, primary } = this.appConfig.colors;
      let series = [
        {
          name: "Revenue",
          data: this.revenue.map((s) => {
            return {
              name: s.label,
              y: s.data,
            };
          }),
        },
      ];
      return {
        chart: {
          type: "pie",
          height: 120,
        },
        credits: {
          enabled: false,
        },
        title: false,
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false,
            },
            borderColor: null,
            showInLegend: true,
            innerSize: 60,
            size: 100,
            states: {
              hover: {
                halo: {
                  size: 1,
                },
              },
            },
          },
        },
        colors: [danger, warning, primary],
        legend: {
          align: "right",
          verticalAlign: "middle",
          layout: "vertical",
          itemStyle: {
            color: "#495057",
            fontWeight: 100,
            fontFamily: "Montserrat",
          },
          itemMarginBottom: 5,
          symbolRadius: 0,
        },
        exporting: {
          enabled: false,
        },
        series,
      };
    },
  },
  mounted() {
    this.receiveDataRequest();
    this.loaddata();
    this.loadDataDashboard();
    this.totalRows = this.items.length;
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" />
